"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4433%3A514))
 * @trackcomponent
 * @lastsynced 2023-10-27T16:52:44.132Z
 */
export const ThumbsDown = createSVGIcon(
  <>
    <path
      d="M2.21826 3.51465H6.08108V13.7992H2.21826C2.00212 13.7992 1.79484 13.7133 1.64201 13.5605C1.48918 13.4077 1.40332 13.2004 1.40332 12.9842V4.32959C1.40332 4.11345 1.48918 3.90617 1.64201 3.75334C1.79484 3.60052 2.00212 3.51465 2.21826 3.51465Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.08105 13.7991L10.2209 20.4164C10.3814 20.678 10.6068 20.8935 10.8753 21.042C11.1438 21.1905 11.4462 21.2671 11.753 21.264C11.9947 21.2727 12.2356 21.2329 12.4616 21.1468C12.6876 21.0609 12.8941 20.9305 13.0688 20.7634C13.2436 20.5961 13.383 20.3957 13.479 20.1738C13.5749 19.9518 13.6254 19.7129 13.6274 19.4711V14.7281H20.7826C21.047 14.7196 21.3065 14.6551 21.5443 14.5391C21.782 14.423 21.9924 14.2579 22.1617 14.0547C22.331 13.8515 22.4556 13.6147 22.5269 13.36C22.5982 13.1052 22.6146 12.8383 22.5755 12.5767L21.2716 4.16652C21.2159 3.71707 20.998 3.3034 20.6589 3.00327C20.3197 2.70313 19.8827 2.53719 19.4297 2.53665H8.73775C8.22878 2.53466 7.72639 2.65188 7.27086 2.87892L6.09735 3.46568"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.08105 13.7994V3.51489"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ThumbsDown",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
